module.exports = __webpack_public_path__ + "static/404-068625b40f6f89ee247b644f1dd02a0a.png";